import React, { Component,Fragment } from 'react';
import RowMaker from './rowMaker';

class MainRows extends Component {
  renderRows(token) {
    return this.props.allrows.map((row, index) => (
      <RowMaker row={row} key={index} token={token} />
    ));
  }
  
  render() {
    return (
      <Fragment>
        {this.renderRows(this.props.token)}
      </Fragment>
    );
  }
}

export default MainRows;